var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{style:({
    marginTop: '15px',
    marginBottom: '15px',
    width: '100%',
    border: '0',
    borderTop: '1px solid'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }